import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useUiStateStore = defineStore(
  'ui-state',
  () => {
    const dashboardInsightsExpanded = ref(true);
    const accountsHeroExpanded = ref(true);

    return {
      dashboardInsightsExpanded,
      accountsHeroExpanded,
    };
  },
  {
    persist: true,
  },
);
